<template>
    <label class="data-range-item">
        <el-checkbox v-model="check" @change="changeSelection">
            <template v-if="obj">
                <span class="text"><img v-if="showImg && obj.url" :src="obj.url" :alt="obj.name"> {{obj.name}}</span>
            </template>    
        </el-checkbox>
    </label>
</template>
<script>
    import countryAndAreaOptions from './countryAndAreaOptions'
    export default {
        props:{
            isChecked:{
              type:Boolean,
                default:false
            },
            value:{
              type:String
            },
            showImg:{
                type:Boolean,
                default:true
            },
            countryAndAreaMapJson:{
                type:String,
                default:''
            }
        },
        mounted(){
            if(this.countryAndAreaMapJson.length > 0){
                var tempMap = this._jsonToMap(this.countryAndAreaMapJson);
                if(tempMap && tempMap.size > 0){
                    this.obj = tempMap.get(this.value)
                }
            }else{
                this.obj = countryAndAreaOptions.get(this.value)
            }
            this.check = this.isChecked
            if(this.showImg && this.obj.imgNo){
                this.obj.url = require('../../../../public/image/country/country' + this.obj.imgNo + '.jpg')
            }

        },
        watch:{
          check(val){
            //   console.log(val)
          },
          isChecked(){
               this.check = this.isChecked
          },
        },
        data(){
            return {
                obj:{},
                check:false
            }
        },
        methods:{
             _objToStrMap(obj){
                let strMap = new Map();
                for (let k of Object.keys(obj)) {
                    strMap.set(k,obj[k]);
                }
                return strMap;
            },
            /**
             *json转换为map
            */
            _jsonToMap(jsonStr){
                return this._objToStrMap(JSON.parse(jsonStr));
            },
            changeSelection(){
                this.$emit('dataRangeItemChanged',this.value,this.check)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .data-range-item{
        display: inline-block;
        margin-bottom: 5px;
        font-size: 14px;
        .text{
            display: inline-block;
            margin-left: 10px;
            img{
                border: 0;
                vertical-align: middle;
            }
        }
        
    }
</style>
<style lang="scss">
 .data-range-item{
    .el-checkbox{
        color: #404040;
    }
    .el-checkbox__input.is-checked+.el-checkbox__label {
        color: #404040;
    }
}
</style>

